export default "__VITE_ASSET__CD47vhi4__"